import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GifItem from "./GifItem";

const ModChatGIFModal = ({
  user,
  getGifs,
  getGifsSearch,
  gifs,
  modmessage,
  showModGIFSearch,
  setShowModGifs,
  setModGif,
  foundModGif,
  sendModMessage,
  setModMessage,
}) => {
  const inputRef = useRef(null);

  const [text, setText] = useState("");
  const [gifSearch, setGifSearch] = useState(false);

  const maxLength = 100;

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  return (
    <Fragment>
      <div className="create-post-overlay">
        <form
          className="create-post-box"
          onSubmit={(e) => {
            e.preventDefault();
            if (foundModGif !== "" || modmessage !== "") {
              sendModMessage(e);
              setModGif("");
              setShowModGifs(false);
            }
          }}
        >
          <div className="create-post-avi-text">
            <div className="create-post-avi-container">
              <img
                className="create-post-avi"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  user && user.avatar
                }`}
                alt="avatar"
              />
            </div>
            <div className="create-post-text-container">
              <div>
                {showModGIFSearch && foundModGif === "" && (
                  <div className="comment-gif-input-hidden-chat">
                    <div className="giphy-container-post">
                      <div className="wrap-container-alt">
                        <div
                          className={`powered-by-giphy-alt ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Powered By
                        </div>
                        <img
                          src={
                            "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                          }
                          style={{
                            width: "80px",
                            margin: "0px 10px",
                          }}
                          alt="logo"
                        />
                      </div>
                      <div
                        className="gifs-alt"
                        id={`${
                          user && user.role === "innovator"
                            ? "green-scroll"
                            : user && user.role === "mentor"
                            ? "red-scroll"
                            : user && user.role === "employer"
                            ? "blue-scroll"
                            : ""
                        }`}
                      >
                        {!gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setModGif(e.target.attributes["src"].value);
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                        {gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setModGif(e.target.attributes["src"].value);
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                      </div>
                      <form
                        className="gif-input-hidden"
                        onSubmit={(e) => {
                          e.preventDefault();
                          getGifsSearch({ text });
                          setText("");
                          setGifSearch(true);
                        }}
                      >
                        <input
                          type="text"
                          className="gif-input"
                          name="text"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          placeholder="Search for GIFs..."
                        />
                        <button
                          type="submit"
                          onSubmit={(e) => {
                            e.preventDefault();
                            getGifsSearch({ text });
                            setText("");
                            setGifSearch(true);
                            setShowModGifs(false);
                          }}
                          className={`gif-input-button ${
                            user && user.role === "innovator"
                              ? "background-green"
                              : user && user.role === "mentor"
                              ? "background-red"
                              : user && user.role === "employer"
                              ? "background-blue"
                              : ""
                          }`}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                )}
                {foundModGif !== "" && (
                  <div className="flex-only-container">
                    <img
                      src={foundModGif}
                      alt="upload-file-avatar"
                      className="upload-file"
                    />
                    <i
                      className="far fa-times fa-lg selected-gif-x-alt"
                      onClick={() => {
                        setModGif("");
                      }}
                    ></i>
                  </div>
                )}
              </div>
            </div>
            <div>
              <i
                className="fas fa-times fa-3x clear"
                onClick={() => setShowModGifs(false)}
              ></i>
            </div>
          </div>
          <div className="comment-reply-input-hidden-alt">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                user && user.avatar
              }`}
              className="chat-avi-user"
              alt="avatar"
            />
            <input
              className="comment-reply-input-alt"
              type="text"
              value={modmessage}
              ref={inputRef}
              onChange={(e) => setModMessage(e.target.value)}
              maxLength={100}
              onKeyPress={(e) => {
                if (modmessage.length <= maxLength && e.key === "Enter") {
                  sendModMessage(e);
                }
              }}
              placeholder="Type your message here..."
            />
            <p className="white character-counter-comment">
              {modmessage.length}/{maxLength} characters
            </p>
          </div>
          <div className="create-post-button-container">
            <button
              className={`create-post-button-alt ${
                user && user.role === "innovator"
                  ? "background-green"
                  : user && user.role === "mentor"
                  ? "background-red"
                  : "background-blue"
              }`}
            >
              <i className="fa-solid fa-comments mx-5"></i>Add ModChat Message
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

ModChatGIFModal.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(ModChatGIFModal);
